import { Dialog, DialogContent } from '@mui/material'
import { Button } from 'components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from 'components/ui/card'
import { ArrowLeft, Badge, Check, TrendingUp, Zap } from 'lucide-react'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectUserDetails } from 'slices/userProfile/reducer'

const FeaturePlan = ({showPlanModal,handleCloseModal,step,handleChoosePlan,setStep,selectedPlan}:{showPlanModal:any,handleCloseModal:any,step:any,handleChoosePlan:any,setStep:any,selectedPlan:any}) => {
    const userDetails = useSelector(selectUserDetails)
    const plans = [
        {
          name: "Basic Plan",
          price: "$29/month",
          features: [
            "10 featured contracts per month",
            "Priority in search results",
            "Basic analytics",
            "Email support"
          ]
        },
        {
          name: "Professional Plan",
          price: "$79/month",
          features: [
            "50 featured contracts per month",
            "Top priority in search results",
            "Advanced analytics & insights",
            "Priority email & chat support",
            "Custom branding"
          ],
          recommended: true
        },
       
      ];
    return (
        <div>
     <Dialog open={showPlanModal} className='tailwind-prefix lead-feature-dialog' >
    <DialogContent style={{
    }} className="   max-h-[90vh] overflow-y-auto p-4 sm:p-6">
      <div className=''>
        <div className="flex items-center gap-2">
          {step === "plans" && (
            <>
              <Zap className="h-5 w-5 sm:h-6 sm:w-6 text-yellow-500" />
              Get More Leads with Featured Contracts
            </>
          )}
          {step === "confirmation" && (
            <>
              <Check className="h-5 w-5 sm:h-6 sm:w-6 text-green-600" />
              Confirm Your Purchase
            </>
          )}
        </div>
        <div>
          {step === "plans" && "Boost your visibility and get 3x more leads by featuring your contracts"}
          {step === "confirmation" && "Review your order before completing the purchase"}
        </div>
      </div>

      <div className="space-y-4 sm:space-y-6 mt-4">
        {/* Plans View */}
        {step === "plans" && (
          <>
            {/* Benefits Section */}
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 sm:p-6 rounded-lg">
              <h3 className="flex items-center gap-2 mb-3 sm:mb-4">
                <TrendingUp className="h-4 w-4 sm:h-5 sm:w-5 text-blue-600" />
                Why Feature Your Contracts?
              </h3>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <Check className="h-4 w-4 sm:h-5 sm:w-5 text-green-600 mt-0.5 flex-shrink-0" />
                  <span>Appear at the top of search results</span>
                </li>
                <li className="flex items-start gap-2">
                  <Check className="h-4 w-4 sm:h-5 sm:w-5 text-green-600 mt-0.5 flex-shrink-0" />
                  <span>Get noticed by more potential clients</span>
                </li>
                <li className="flex items-start gap-2">
                  <Check className="h-4 w-4 sm:h-5 sm:w-5 text-green-600 mt-0.5 flex-shrink-0" />
                  <span>Increase your conversion rate by 300%</span>
                </li>
                <li className="flex items-start gap-2">
                  <Check className="h-4 w-4 sm:h-5 sm:w-5 text-green-600 mt-0.5 flex-shrink-0" />
                  <span>Stand out with premium placement badges</span>
                </li>
              </ul>
            </div>

            {/* Plans Grid */}
            <div className="grid grid-cols-1  sm:grid-cols-2 lg:grid-cols-2 gap-4 sm:gap-6">
              {plans.map((plan, index) => (
                <Card key={index} className={plan.recommended ? "border-blue-500 border-2 relative  " : ""}>
                  {plan.recommended && (
                    <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                      <Badge className="bg-blue-600">Recommended</Badge>
                    </div>
                  )}
                  <CardHeader className="p-4 sm:p-6">
                    <CardTitle>{plan.name}</CardTitle>
                    <div className="text-gray-900">{plan.price}</div>
                  </CardHeader>
                  <CardContent className="p-4 sm:p-6 pt-0">
                    <ul className="space-y-2 sm:space-y-3">
                      {plan.features.map((feature, idx) => (
                        <li key={idx} className="flex items-start gap-2">
                          <Check className="h-4 w-4 text-green-600 mt-0.5 flex-shrink-0" />
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                    <Button
                      className="w-full mt-4 sm:mt-6" 
                      variant={plan.recommended ? "default" : "outline"}
                      onClick={() => handleChoosePlan(index)}
                    >
                      Choose Plan
                    </Button>
                  </CardContent>
                </Card>
              ))}
            </div>

            {/* Call to Action */}
            <div className="bg-gray-100 p-3 sm:p-4 rounded-lg text-center">
              <p className="text-gray-600">
                Not sure which plan is right for you? <Button variant="link" className="p-0 h-auto">Contact our sales team</Button>
              </p>
            </div>
          </>
        )}

        {/* Confirmation */}
        {step === "confirmation" && selectedPlan !== null && (
          <div className="max-w-2xl mx-auto w-full space-y-6">
            <div className="bg-green-50 border border-green-200 p-4 sm:p-6 rounded-lg">
              <div className="flex items-start gap-3">
                <Check className="h-6 w-6 text-green-600 flex-shrink-0" />
                <div>
                  <h3 className="font-medium text-green-900">Ready to boost your leads!</h3>
                  <p className="text-green-700 mt-1">Review your order details below and confirm your purchase.</p>
                </div>
              </div>
            </div>

            <Card>
              <CardHeader>
                <CardTitle>Order Summary</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="flex items-center justify-between pb-4 border-b">
                  <div>
                    <p className="font-medium">{plans[selectedPlan].name}</p>
                    <p className="text-gray-600">Billed monthly</p>
                  </div>
                  <p className="text-gray-900">{plans[selectedPlan].price}</p>
                </div>
                <div>
                  <h4 className="font-medium mb-2">Features included:</h4>
                  <ul className="space-y-2">
                    {plans[selectedPlan].features.map((feature, idx) => (
                      <li key={idx} className="flex items-start gap-2 text-gray-700">
                        <Check className="h-4 w-4 text-green-600 mt-0.5 flex-shrink-0" />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Billing Information</CardTitle>
              </CardHeader>
              <CardContent className="space-y-2">
                <div className="flex justify-between">
                  <span className="text-gray-600">Name:</span>
                  <span className="font-medium">{userDetails.name}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Email:</span>
                  <span className="font-medium">{userDetails.email}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Company:</span>
                  <span className="font-medium">{userDetails.company}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Payment Method:</span>
                  <span className="font-medium capitalize">Credit / Debit Card ({userDetails.savedCard})</span>
                </div>
              </CardContent>
            </Card>

            <div className="flex items-center justify-between pt-4">
              <Button 
                variant="outline" 
                onClick={() => setStep("plans")}
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Edit Details
              </Button>
              <Button 
                onClick={handleCloseModal}
                className="bg-green-600 hover:bg-green-700"
              >
                Confirm & Complete Purchase
              </Button>
            </div>
          </div>
        )}
      </div>
    </DialogContent>
  </Dialog>
        </div>
       
  )
}

export default FeaturePlan
